<template>
  <div class="about">
    <!-- Masthead -->
    <header class="masthead testimonials text-white text-center">
      <div class="overlay"></div>
      <div class="container">
        <div class="row">
          <div class="col-xl-9 mx-auto">
            <h1>Testimonials</h1>
            <h5 class="mb-5">See what some of our clients have to say about us</h5>
          </div>
        </div>
      </div>
    </header>

    <section class="pt-5 pb-5 bg-light">
      <div class="container">

        <div v-for="(i, j) in testimonials" v-bind:key="i.client">
          <div class="row">
            <div class="col-md-7 mt-0" :class="{ 'order-md-2': j % 2 == 0 }">
              <h2>
                {{i.client}}
                <small class="text-muted">since {{i.since}}</small>
              </h2>
              <blockquote class="blockquote">
                <p class="lead">{{i.body}}</p>
                <footer class="blockquote-footer">
                  {{i.author}}
                  <small class="text-muted">
                    {{i.title}},
                    <a :href="i.link">{{i.client}}</a>
                  </small>
                </footer>
              </blockquote>
            </div>
            <div class="col-md-5 mt-0 d-flex flex-wrap align-items-center" :class="{ 'order-md-1': j % 2 == 0 }">
              <a :href="i.link" class="mx-auto">
                <img class="img-fluid" :src="i.image">
              </a>
            </div>
          </div>

          <hr class="my-5" v-if="j != testimonials.length - 1" />
        </div>

      </div>
    </section>

    <!-- Call to Action -->
    <footer-cta />
  </div>
</template>

<script>
import footerCta from '@/components/footer_cta.vue'

export default {
  name: 'testimonials',
  components: {
    footerCta
  },
  data () {
    return {
      testimonials: [
        {
          author: 'Eryn Warden',
          title: 'CEO',
          client: 'TouchBase Mail',
          since: '2014',
          link: 'https://touchbasemail.com',
          image: require('@/assets/img/client-touchbase.png'),
          body: `
            We have been making use of Reenigne for our cloud servers since day one.
            We have a very dynamic architecture that requires us to scale up and down constantly, and Reenigne has been an excellent provider that has assisted us through the many stages of our scale.`
        },
        {
          author: 'Luke C. Todesco',
          title: 'President and CEO',
          client: 'Social Media Group',
          since: '2016',
          link: 'https://gustazos.com',
          image: require('@/assets/img/client-gustazos.png'),
          body: `
            Reenigne has been a reliable cloud service solution for our group of companies for many years now, and has consistently shown a superior level of knowledge and customer support in an industry known to be lacking in this area.
            From our Email Marketing company to our E-Commerce sites, our group continues to trust Reenigne's services and I look forward to working with their team for years to come.`
        },
        // {
        //   author: 'Paul T.',
        //   title: 'President and CEO',
        //   client: 'GuestServe',
        //   since: '2014',
        //   link: 'https://guestserve.com',
        //   image: require('@/assets/img/client-guestserve.png'),
        //   body: 'Yay Reenigne or something Yay Reenigne or something Yay Reenigne or something Yay Reenigne or something Yay Reenigne or something Yay Reenigne or something Yay Reenigne or something Yay Reenigne or something Yay Reenigne or something Yay Reenigne or something Yay Reenigne or something Yay Reenigne or something'
        // },
        {
          author: 'Alejandro L.',
          title: 'Lead Developer',
          client: 'Fangig',
          since: '2015',
          link: 'https://fangig.com',
          image: require('@/assets/img/client-fangig.png'),
          body: `
            Simplicity, transparency in pricing and spectacular support.
            From my first consultation by 2015 to our daily operations, Reenigne does what it takes to get the job done right.
            They combine the power of always-on service and expertise with the best in tools and automation to deliver technology whenever its requested.
            Moving from Rackspace to Reenigne, not only was I able to save 45% on my cloud infrastructure cost, but also saw a 50% improvement in performance and the best support a customer can get.`
        }
      ]
    }
  }
}
</script>
